import {FieldSettingsOptions} from "PDFImporter/Manager/PDFManager/DocumentManager.Options";
import {DocumentManager} from "PDFImporter/Manager/PDFManager/DocumentManager";
import {AutoCompleteDictionary} from "./AutoCompleteDictionary";


export class FormulaAutocomplete
{

    public process(editor,  field: FieldSettingsOptions,documentManager:DocumentManager):ListGenerator
    {
        let cursor:CodeMirrorCursor = editor.getCursor();

        let line:string = editor.getLine(cursor.line);
        let start = cursor.ch;
        let end = cursor.ch;

        if((start>0&&line.charAt(start-1)==' ')||(line.length==0||line.charAt(0)==""))
            return this.GenerateList(editor)
                .AddItem('Math','','Math','Here you will find advanced arithmetic operations like sin or pow')
                .AddItem('Math','','Math','Here you will find advanced arithmetic operations like sin or pow');

       /* if(this.IsRemoteNerby(cursor,line))
            return this.GenerateList(editor)
                .AddItem('Get:','Get($$URL$$,$$Args$$)','Get(URL,Args)','Execute a Get request using the specified $$URL$$ and $$Args$$(optional)')
                .AddItem('Post:','Get($$URL$$,$$Args$$)','Post(URL,Args)','Execute a Post request using the specified $$URL$$ and $$Args$$(optional)');*/

        if(this.IsOpeningBrackets(cursor,line,editor))
        {
            return this.GetFieldList(editor,documentManager);
        }

        if(this.IsMathNerby(cursor,line))
            return this.GenerateList(editor)
                .AddItem('Abs:','abs($$x$$)','abs(x)','Returns the absolute value of $$x$$')
                .AddItem('Acos:','acos($$x$$)','acos(x)','Returns the arccosine of $$x$$, in radians')
                .AddItem('Asin:','asin($$x$$)','asin(x)','Returns the arcsine of $$x$$, in radians')
                .AddItem('Atan:','atan($$x$$)','atan(x)','Returns the arctangent of $$x$$ as a numeric value between -PI/2 and PI/2 radians')
                .AddItem('Ceil:','atan2($$y$$,$$x$$)','atan2(y,x)','Returns the arctangent of the quotient of its arguments')
                .AddItem('Atan2:','atan2($$y$$,$$x$$)','atan2(y,x)','Returns the arctangent of the quotient of its arguments')
                .AddItem('Ceil:','ceil($$x$$)','ceil(x)','Returns the value of $$x$$ rounded up to its nearest integer')
                .AddItem('Cos:','cos($$x$$)','cos(x)','Returns the cosine of $$x$$ ($$x$$ is in radians)')
                .AddItem('Exp:','exp($$x$$)','exp(x)','Returns the value of e<sup style="vertical-align: super;font-size: smaller;">$$x$$</sup>')
                .AddItem('Floor:','floor($$x$$)','floor(x)','Returns the value of $$x$$ rounded down to its nearest integer')
                .AddItem('Log:','log($$x$$)','log(x)','Returns the natural logarithm (base E) of $$x$$')
                .AddItem('Max:','max($$x$$, $$y$$, $$z$$, ..., $$n$$)','max(x, y)','Returns the number with the highest value')
                .AddItem('Min:','min($$x$$, $$y$$, $$z$$, ..., $$n$$)','min(x, y)','Returns the number with the lowest value')
                .AddItem('Pow:','pow($$x$$, $$y$$)','pow(x, y)','Returns the value of $$x$$ to the power of $$y$$')
                .AddItem('Random:','random()','random()','Returns a random number between 0 and 1')
                .AddItem('Sin:','sin($$x$$)','sin(x)','Returns the sine of $$x$$ ($$x$$ is in radians)')
                .AddItem('Sqrt:','sqrt($$x$$)','sqrt(x)','Returns the square root of $$x$$')
                .AddItem('Tan:','tan($$x$$)','tan(x)','Returns the tangent of an angle');


        if(this.IsFieldNerby(cursor,editor))
            return this.GetIntellisenceforField(editor,cursor,line,field,documentManager);

        return null;



    }




    private GenerateList(editor:any):ListGenerator
    {
        return new ListGenerator(editor);
    }

    private IsFieldNerby(cursor: CodeMirrorCursor, editor: any) {

        let token=editor.getTokenAt(cursor);
        let prevToken=editor.getTokenAt({line:cursor.line,ch:cursor.ch-1});
        return token!=null&&token.string=='.'&&prevToken!=null&&prevToken.type=='field';



    }

    private IsMathNerby(cursor: CodeMirrorCursor, line: string) {
        return cursor.ch >= 5 && line.substr(cursor.ch - 5,5) =='Math.';

    }

    private IsRemoteNerby(cursor: CodeMirrorCursor, line: string) {
        return cursor.ch >= 7 && line.substr(cursor.ch - 7,7) =='Remote.';

    }

    private GetFieldById(id:string,field: FieldSettingsOptions,documentManager:DocumentManager):{Id:string,Label:string,Type:string,Items:any[]}{

        let fields=documentManager.GetFields();
        return fields.find(x=>x.Id==id as any) as any;
    }

    private GetIntellisenceforField(editor:any ,cursor: CodeMirrorCursor, line: string,sourceField: FieldSettingsOptions,documentManager:DocumentManager) {
        let prevToken=editor.getTokenAt({line:cursor.line,ch:cursor.ch-1});
        let fieldId=prevToken.state.FieldId;
        let field=this.GetFieldById(fieldId,sourceField,documentManager);

        if(field.Type=='List')
        {
            let list=this.GenerateList(editor);
            list.AddItem('GetCell','','GetCell(rowIndex,columnIndex)','Get a cell from the list');
            return list;
        }

        if(field.Type=='Composed')
        {
            let list=this.GenerateList(editor);
            for(let currentItem of field.Items)
            {
                list.AddItem(currentItem.Label,'','GetSection("'+currentItem.Id+'")','');
            }
            return list;
        }

        if((field as any).SubType=='product')
        {
            let list=this.GenerateList(editor);
            list.AddItem('GetPrice','','GetPrice()','Get the product price');
            return list;
        }

        return null;
    }

    private IsOpeningBrackets(cursor: CodeMirrorCursor, line: string,editor:any) {

        let token=editor.getTokenAt(cursor);
        let previousToken=editor.getTokenAt({line:cursor.line,ch:cursor.ch-1});
        if(token.state.lastType=='string')
            return false;
        return cursor.ch >= 1 && line.substr(cursor.ch - 1,1) =='$'&&previousToken.type!='field';
    }

    private GetFieldList(editor: any, documentManager: DocumentManager) {
        let fields=documentManager.GetFields();


        let generator=this.GenerateList(editor)
            .SetSuffix('$');

        for(let currentField of fields)
            generator.AddItem((currentField.Label!=''?currentField.Label+' ':'')+`(Id: ${currentField.Id})`,'','Field '+currentField.Id,'');

        if(fields.length==0) {
            generator.SetPrefix('');
            generator.SetSuffix('');
            generator.AddItem('There are no available fields to select', '', '', '');
        }
        return generator;
    }
}

class ListGenerator{
    public data:any;
    public suffix:string;
    public prefix:string;

    public Render(container:any,data,cursor)
    {
        container.innerHTML=cursor.label
    }

    constructor(editor:any){
        let cursor=editor.getCursor();
        this.suffix='';
        this.prefix='';
        this.data={
            type:'html',
            list:[],
            from:cursor,
            to:cursor
        }
    }


    SetSuffix(suffix:string)
    {
        this.suffix=suffix;
        return this;
    }

    SetPrefix(suffix:string)
    {
        this.prefix=suffix;
        return this;
    }
    AddItem(label:string,label2:string,value:string,description:string):ListGenerator{
        let colorDictionary={};
        let labelElement=`<div style="line-height: 1.2em;padding:3px 0 3px 0;"><span class="sfFormulaLabel">${this.StylizeText(colorDictionary,label)}</span>${label2!=''?`<span class="sfFormulaLabel2">${this.StylizeText(colorDictionary,label2)}</span>`:''}<span class="sfFormulaDescription">${this.StylizeText(colorDictionary,description)}</span></div>`;
        this.data.list.push({label:labelElement,text:this.prefix+value+this.suffix,render:this.Render});
        return this;
    }


    private StylizeText(colorDictionary:any,label: string) {

        let reg=/\$\$([^(\$\$)]+)\$\$/g
        let m;
        let count=-1;
        let colors=['red','blue','#008000','#8B008B'];
        while(m=reg.exec(label))
        {
            let color;
            if(typeof colorDictionary[m[1]]!='undefined')
                color=colorDictionary[m[1]];
            else{
                count++;
                color=colors[count];
                colorDictionary[m[1]]=color;
            }



            label=label.replace(m[0],`<span style="color:${color}">${m[1]}</span>`);
            reg.lastIndex=0;
        }
        return label;
    }
}

interface CodeMirrorCursor{
    ch:number;
    line:number;
}

declare let SFAutoCompleteFieldDictionary:any;